export default "<app-notes-search></app-notes-search>\r\n\r\n<router-outlet></router-outlet>\r\n"